import { API_PATHS, interpolatePathParams, REQUEST_METHODS, ROUTE_PARAMS } from '@futrli/shared-services';
import { APIClients } from '@futrli/shared-services';

/**
 * Set MFA type
 */
export const setUsersMfa = async (userId: string): Promise<void> => {
  const path = interpolatePathParams(API_PATHS.USERS_MFA, { [ROUTE_PARAMS.USER_ID]: userId });
  await APIClients.getAPIClient().makeRequest({
    payload: {
      request: {
        url: path,
        method: REQUEST_METHODS.PUT
      }
    }
  });

  return;
};

/**
 * Disable MFA
 */
export const disableUsersMfa = async (userId: string): Promise<void> => {
  const path = interpolatePathParams(API_PATHS.USERS_MFA, { [ROUTE_PARAMS.USER_ID]: userId });
  await APIClients.getAPIClient().makeRequest({
    payload: {
      request: {
        url: path,
        method: REQUEST_METHODS.DELETE
      }
    }
  });

  return;
};
